import { HeaderImage } from "Components"
import React from "react"
import Modal from "react-modal"
import styled from "styled-components"

const Container = styled.div`
  padding: 2rem;
`

export default (props) => {
  const { currentAudience, isOpen, closeModal, onAfterOpen, onRequestClose } = props

  return (
    <Modal
      id="modalAudience"
      contentLabel="modalAudience"
      closeTimeoutMS={400}
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}>
      <HeaderImage
        title={currentAudience ? currentAudience.displayName : ""}
        image={currentAudience ? currentAudience.banner : ""}
      />
      <button className="btn-close" onClick={closeModal}>
        X
      </button>
      <Container>{currentAudience ? currentAudience.copy : ""}</Container>
    </Modal>
  )
}
